(function () {
  'use strict';

  function initCarousel(section) {
    var swiperEl = section.querySelector('[data-lifestyle-swiper]');
    var tabsWrap = section.querySelector('[data-lifestyle-tabs]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var tabs = tabsWrap ? Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-lifestyle-tab]')) : [];
    var paginationEl = section.querySelector('[data-lifestyle-pagination]');
    var autoplay = section.dataset.autoplay === 'true';
    var delay = parseInt(section.dataset.autoplayDelay, 10) || 5000;

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      speed: 500,
      autoplay: autoplay ? { delay: delay, disableOnInteraction: false } : false,
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true
      } : false,
      on: {
        slideChange: function (s) {
          setActiveTab(s.activeIndex);
        }
      }
    });

    function setActiveTab(index) {
      tabs.forEach(function (tab) {
        var isActive = parseInt(tab.dataset.index, 10) === index;
        tab.classList.toggle('is-active', isActive);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = parseInt(tab.dataset.index, 10);
        swiper.slideTo(index);
        if (autoplay && swiper.autoplay) swiper.autoplay.stop();
      });
    });
  }

  function initStagger(section) {
    if (section.dataset.introAnimate !== 'true') return;

    var eyebrow = section.querySelector('[data-ls-intro]');
    var words = Array.prototype.slice.call(section.querySelectorAll('[data-ls-word]'));
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-lifestyle-tab]'));
    var reels = Array.prototype.slice.call(section.querySelectorAll('[data-ls-reel]'));

    var i = 0;
    if (eyebrow) eyebrow.style.setProperty('--i', i++);
    words.forEach(function (w) { w.style.setProperty('--i', i++); });
    tabs.forEach(function (t) { t.style.setProperty('--i', i++); });
    // Reels stagger in as a tight group right after the tabs,
    // rather than continuing the same long delay chain (which
    // would make the last reel wait a full second-plus to appear).
    var reelStart = i;
    reels.forEach(function (r, idx) { r.style.setProperty('--i', reelStart + idx); });

    if (!('IntersectionObserver' in window)) {
      section.setAttribute('data-in-view', 'true');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Wait two animation frames before revealing. If we flip
            // the attribute in the same frame the browser laid out
            // the "hidden" (opacity:0) state, the browser can collapse
            // both style changes into one paint and the transition
            // never visibly plays — everything just appears at once
            // instead of staggering. Two rAFs guarantee the hidden
            // state has actually been painted first.
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                section.setAttribute('data-in-view', 'true');
              });
            });
          } else {
            // Leaving the viewport in either direction resets the
            // animation so it plays again next time it scrolls in.
            section.removeAttribute('data-in-view');
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(section);
  }

  function initSection(section) {
    if (section.dataset.lifestyleInitialized === 'true') return;
    section.dataset.lifestyleInitialized = 'true';
    initCarousel(section);
    initStagger(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lifestyle-showcase]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor support: re-init when the section is added/reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();